import gql from 'graphql-tag';

const query = gql`
    query SaleProductLoad($promoCode: String) {
        sale {
            productVariants(promoCode: $promoCode) {
                id
                name
                saleProduct {
                    name
                    price {
                        regular {
                            amount
                            currency
                        }
                        promo {
                            amount
                            currency
                        }
                    }
                    isVirtual
                    containsDiet
                    containsWorkout
                    tags
                    isBestseller
                    longDescription
                    lengthLabel
                    vendor {
                        identifier
                    }
                }
            }
        }
    }
`;

export default query;
